import { differenceInDays } from 'date-fns';
import { injectable } from 'inversify';
import { Attribute, Component } from '../../../concepts/objects';
import { LensAspect } from '../lens/LensAspect';
import { LensAspectProvider } from '../lens/LensAspectProvider';
import { RoadmapCard } from './RoadmapCard';
import { RoadmapCardEndDate, RoadmapCardStartDate, RoadmapCardTargetDate } from './RoadmapCardAssocs';

const readAttr = (elmt: Component, attr: Attribute<Date, RoadmapCard>) => {
    const card = elmt.as(RoadmapCard);
    return !!card ? attr.get(card) : null;
};

const aspects = [
    LensAspect.create(
        'Date',
        'RoadmapCard.startDate',
        'startDate',
        'The start date of the item represented by this card.',
        'property',
        (elmt: Component) => readAttr(elmt, RoadmapCardStartDate)
    ),
    LensAspect.create(
        'Date',
        'RoadmapCard.endDate',
        'endDate',
        'The end date of the item represented by this card.',
        'property',
        (elmt: Component) => readAttr(elmt, RoadmapCardEndDate)
    ),
    LensAspect.create(
        'Date',
        'RoadmapCard.originalEndDate',
        'originalEndDate',
        'The original end date of the item represented by this card.',
        'property',
        (elmt: Component) => readAttr(elmt, RoadmapCardTargetDate)
    ),
    LensAspect.create(
        'number',
        'RoadmapCard.daysEarly',
        'daysEarly',
        'The number of days early the item represented by this card is.',
        'property',
        (elmt: Component) => {
            const original = readAttr(elmt, RoadmapCardTargetDate);
            const end = readAttr(elmt, RoadmapCardEndDate);
            if (!!end && !!original && end < original) {
                return differenceInDays(original, end);
            }
            return !!end ? 0 : null;
        }
    ),
    LensAspect.create(
        'number',
        'RoadmapCard.daysLate',
        'daysLate',
        'The number of days late the item represented by this card is.',
        'property',
        (elmt: Component) => {
            const original = readAttr(elmt, RoadmapCardTargetDate);
            const end = readAttr(elmt, RoadmapCardEndDate);
            if (!!end && !!original && end > original) {
                return differenceInDays(end, original);
            }
            return !!end ? 0 : null;
        }
    ),
];

@injectable()
export class RoadmapCardLensAspectProvider implements LensAspectProvider {

    public getAspectsFor(elmts: Component[]): LensAspect[] {
        if (!elmts.some(x => x.is(RoadmapCard))) return [];
        return aspects;
    }
}
